import {
    fontWeight,
    textDecorations,
    textTransformations,
    textAligns,
} from '../constants/components';

export const componentsMixin = {
    computed: {
        components() {
            return {
                fontWeight,
                textDecorations,
                textTransformations,
                textAligns,
            };
        },
    },
};
